import { ReactComponent as GenericAvatar } from "../../Assets/iconsv2/generic/GenericAvatar.svg";
import LogoColor from "../../Assets/icons/logo/logo-small.svg";
import { ReactComponent as QcIcon } from "../../Assets/icons/quickChat/QuickChatIcon.svg";

import styled from "styled-components";


export const extractInitials = (name) => {
  if (!name) return "";

  const words = name.trim().split(/\s+/);

  return words.length === 1
    ? words[0].slice(0, 2).toUpperCase()
    : (words[0][0] + words[1][0]).toUpperCase();
};


export const displayParticipantAvatar = (participant) => {
  if (!participant) {
    return <GenericAvatar />;
  }
  let displayAvatar = <></>;
  let profilePicture = participant.profile_picture;
  let initials = extractInitials(participant.name)

  if (profilePicture) {
    displayAvatar = <img src={profilePicture} alt="avatar" />;
  } else if (initials) {
    displayAvatar = (
      <InitialsAvatarCallParticipants>
        <h5>{initials}</h5>
      </InitialsAvatarCallParticipants>
    );
  } else {
    displayAvatar = <GenericAvatar />;
  }


  return displayAvatar

}

export const displayAvatar = (data) => {
  if (!data) {
    return <GenericAvatar />;
  }

  let displayAvatar = <></>;
  let initials = "";
  let otherParticipant = data?.other_participants[0];
  let profilePicture = null



  if (data.is_call_chat) {
    if (data.call_info?.image) {
      displayAvatar = <CustomAvatar src={data.call_info.image} alt="avatar" />;
    } else {
      const callInitials = extractInitials(data.display_name);
      displayAvatar = (
        <InitialsAvatar>
          <h5>{callInitials}</h5>
        </InitialsAvatar>
      );
    }
  } else if (data.group != null) {
    if (data.group.image) {
      profilePicture = data.group.image;
      displayAvatar = <CustomAvatar src={profilePicture} alt="avatar" />;
    } else {
      const groupInitials = extractInitials(data.group.name);
      displayAvatar = (
        <InitialsAvatar>
          <h5>{groupInitials}</h5>
        </InitialsAvatar>
      );
    }
  } else if (data?.with_emotii) {
      displayAvatar = <CustomAvatar src={LogoColor} alt="avatar" />;
    } else {
      if (data.quick_chat) {
        displayAvatar = <QcIcon />;
      } else
        if (otherParticipant) {
          initials = extractInitials(otherParticipant.name);
          profilePicture = otherParticipant.profile_picture;
          if (profilePicture) {
            displayAvatar = <CustomAvatar src={profilePicture} alt="avatar" />;
          } else {
            if (initials !== "") {
              displayAvatar = (
                <InitialsAvatar>
                  <h5>{initials}</h5>
                </InitialsAvatar>
              );
            } else {
              displayAvatar = <GenericAvatar />;
            }
          }
        }
    }

  return <Container>{displayAvatar}</Container>;
};

export const displayUserAvatar = (user, isSmall = false) => {
  if (!user) {
    return;
  }

  let display = <GenericAvatar />;

  let initials = extractInitials(user.name);

  if (user.profile_picture) {
    display = <CustomAvatar src={user.profile_picture} alt="avatar" />;
  } else {
    if (initials !== "") {
      display = (
        <InitialsAvatar isSmall={isSmall}>
          <h5>{initials}</h5>
        </InitialsAvatar>
      );
    } else {
      display = <GenericAvatar />;
    }
  }

  return <Container>{display}</Container>;
};

const InitialsAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
    width: 100%;
  height: 100%;
  border-radius: 100px;
  background: ${({ theme }) => theme.menu.avatarBackground};

  h5 {
    font-size: ${({ isSmall }) => isSmall ? '14px' : '18px'};
    line-height: ${({ isSmall }) => isSmall ? '14px' : '20px'};
    font-weight: 600;
    color: white;
    text-transform: uppercase;
  }
`;

const InitialsAvatarCallParticipants = styled(InitialsAvatar)`
 h5 {
    font-size: 28px;
    font-weight: 600;
    color: white;
    text-transform: uppercase;
  }
`

const CustomAvatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 100px;
  border: 1px solid ${({ theme }) => theme.sidebar.avatarBorderColor};
`;

const Container = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
